export default "__VITE_ASSET__COUX$EcG__"